import { render, staticRenderFns } from "./BulkEditTransactionModal2.vue?vue&type=template&id=8c46ec58&"
import script from "./BulkEditTransactionModal2.vue?vue&type=script&lang=ts&"
export * from "./BulkEditTransactionModal2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports